$(document).on('click', '.custom_accordion_inner .accordion_title', function () {
    $(this).toggleClass('active').next('.accordion_content').slideToggle();
});
$(document).on('click', '.close_search', function(){
    $('.header .search').removeClass('header__search-inner--open');
    $('body').removeClass('overflow-hidden-search');
});

var firstPrdInfoAcc = $('.mobile-accordion .mobile-accordion-item').first();
firstPrdInfoAcc.addClass('active');
firstPrdInfoAcc.find('.accordion-icon').text('−');


$(document).on('click', '.mobile-accordion-btn', function(){
    var parent = $(this).closest('.mobile-accordion-item');
    
    setTimeout(() => {
        if (parent.hasClass('active')) {
            // Get viewport boundaries
            var scrollTop = $(window).scrollTop();
            var scrollBottom = scrollTop + $(window).height();
            
            // Get element boundaries
            var elementTop = parent.offset().top;
            var elementBottom = elementTop + parent.outerHeight();
            
            // Check if the element is OUTSIDE the viewport
            var isNotInViewport = (elementTop < scrollTop) || (elementBottom > scrollBottom);
            
            if (isNotInViewport) {
                $('html, body').stop().animate({
                    scrollTop: elementTop - 90
                }, 300);
            }
        }   
    }, 300);
});

